export const COPY_PASTE_REGEX =
  /(?:^[\u2028\u00A0\u2029\s]+)|(?:[\u2028\u00A0\u2029\s]+$)/g;
export const HTML_SPECIAL_CHAR_REGEX = /[<>[\]\\{}]/;
export const HTML_SPECIAL_CHAR_ERROR = '\\, <, >, [, ], {, }';
